/*
 * @Author: nsj
 * @Date: 2021-03-02 13:42:44
 * @Description: description
 */
let SXG_baseUrl = "http://192.168.2.78:7011"; //后台访问基地址
let WJ_baseUrl = "http://192.168.2.78:7011"; //后台访问基地址
let login_baseUrl_xmpp = "http://cs1.sino-med.net:8585/xmpp-httpbind" // 登录要连接的xmpp测试地址
SXG_baseUrl = WJ_baseUrl = "http://192.168.2.78:7011";
SXG_baseUrl = WJ_baseUrl = "https://www.elismed.com:411";
login_baseUrl_xmpp = "https://www.sino-med.net:451/xmpp-httpbind"



//测试环境地址
if (process.env.NODE_ENV === "test") {
    SXG_baseUrl = WJ_baseUrl = "http://39.104.135.186:7011";
}
//正式环境地址
if (process.env.NODE_ENV === "production") {
    SXG_baseUrl = WJ_baseUrl = "https://www.elismed.com:411";
    // login_baseUrl_xmpp = "http://www.sino-med.net:8585/xmpp-httpbind"
    login_baseUrl_xmpp = "https://www.sino-med.net:451/xmpp-httpbind"
}

export default {
    SXG_baseUrl,
    WJ_baseUrl,
    login_baseUrl_xmpp
}